import { render } from "./EpsCard.vue?vue&type=template&id=9d871b58&scoped=true"
import script from "./EpsCard.vue?vue&type=script&lang=js"
export * from "./EpsCard.vue?vue&type=script&lang=js"

import "./EpsCard.vue?vue&type=style&index=0&id=9d871b58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d871b58"]])

export default __exports__